import React from "react";
import "../ModalEditWindow.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { closeRequestModal } from "./../../../actions/modals";
import { withTranslation } from "react-i18next";
import EnrollChildComponent from "./../../EnrollChild";
import Zoom from "@material-ui/core/Zoom";

class EnrollChild extends React.Component {

  processLessonTime(time) {
    const d = new Date(+new Date(`2021-06-07 ${time}`) + 1000 * 60 * 60);
    const _min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
    const _hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
    return `${_hours}:${_min}`;
  }

  processGroupName(item) {
    const { t } = this.props;
    const days_schema = {
      0: t("days.mon"),
      1: t("days.tue"),
      2: t("days.wed"),
      3: t("days.thu"),
      4: t("days.fri"),
      5: t("days.sat"),
      6: t("days.sun"),
    };
    return `${t("next_lesson_in")}\n${days_schema[item.lesson_day]} | ${
      item.lesson_time
    } - ${this.processLessonTime(item.lesson_time)}\n${
      days_schema[item.lesson_day_add]
    } | ${item.lesson_time_add} - ${this.processLessonTime(
      item.lesson_time_add
    )}`;
  }

  render() {
    return (
      <>
        {this.props.selectedGroup ? (
          <Zoom in={!!this.props.selectedGroup}>
            <div className="lesson_add">
              {this.processGroupName(this.props.selectedGroup)}
            </div>
          </Zoom>
        ) : null}

        <EnrollChildComponent />
      </>
    );
  }
}

const withForm = connect(
  (state) => ({ selectedGroup: state.cities && state.cities.selectedGroup }),
  (dispatch) =>
    bindActionCreators(
      {
        closeRequestModal,
      },
      dispatch
    )
);

export default withTranslation()(withForm(EnrollChild));
